module.exports = __webpack_public_path__ + "static/media/step-big-full-mobile.504bc383.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/step-big-full-mobile.svg
// module id = 859
// module chunks = 21